import React from 'react';
import { OrderDetailsDTO } from '../../types/order';

interface OrderItemsCardProps {
  order: OrderDetailsDTO;
}

const OrderItemsCard: React.FC<OrderItemsCardProps> = ({ order }) => {
  if (order.items.length === 0) {
    return (
      <div className="bg-white rounded-lg shadow p-6">
        <h3 className="text-lg font-semibold text-gray-900 mb-4">Order Items</h3>
        <div className="text-center py-8 text-gray-500">
          <p>No items in this order</p>
        </div>
      </div>
    );
  }
  
  return (
    <div className="bg-white rounded-lg shadow p-6">
      <h3 className="text-lg font-semibold text-gray-900 mb-4">Order Items</h3>
      <div className="space-y-4">
        {order.items.map((item) => (
          <div
            key={item.id}
            className="border border-gray-200 rounded-lg p-4 hover:border-gray-300 transition-colors"
          >
            <div className="flex justify-between items-start mb-2">
              <div>
                <h4 className="font-medium text-gray-900">{item.garmentType}</h4>
                {item.fabric && (
                  <p className="text-sm text-gray-600 mt-1">Fabric: {item.fabric}</p>
                )}
                {item.clothType && (
                  <p className="text-sm text-gray-600">Cloth Type: {item.clothType}</p>
                )}
              </div>
              <div className="text-right">
                <p className="text-sm text-gray-500">Qty: {item.quantity}</p>
                {item.unitPrice && (
                  <p className="font-medium text-gray-900 mt-1">
                    {(item.unitPrice * item.quantity).toFixed(2)}
                  </p>
                )}
              </div>
            </div>
            {item.measurementSetId && (
              <p className="text-xs text-gray-500 mt-2">
                Measurement Set: {item.measurementSetId}
              </p>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default OrderItemsCard;

